import { AppHostContext } from '@services/appHost';
import React from 'react';
import ScoringStore from './store';
import VBScoringStore from './vbStore';
import GenericScoringStore from './genericStore';
import {
  GenericScoringContext,
  ScoringContext,
  VBScoringContext,
} from './context';

export const ScoringContextsWrapper: React.FC<{
  children: React.ReactNode;
}> = ({ children }) => {
  const appHost = React.useContext(AppHostContext);

  const scoringStore = React.useMemo(
    () => new ScoringStore(appHost),
    [appHost]
  );
  const vbScoringStore = React.useMemo(
    () => new VBScoringStore(appHost),
    [appHost]
  );
  const genericScoringStore = React.useMemo(
    () => new GenericScoringStore(appHost),
    [appHost]
  );

  return (
    <ScoringContext.Provider value={scoringStore}>
      <VBScoringContext.Provider value={vbScoringStore}>
        <GenericScoringContext.Provider value={genericScoringStore}>
          {children}
        </GenericScoringContext.Provider>
      </VBScoringContext.Provider>
    </ScoringContext.Provider>
  );
};
